import { QrCode } from "../../assets";
import { css } from "@emotion/react";
import { AuthContextType, useAuth } from "../../auth/auth-provider";
import Avatar from "../avatar";
import { useEffect, useState } from "react";
import DialogPadrao from "../../components/DialogPadrao";
import { ContainerLeftModal, ContainerRightModal } from "../qrCode/styles";
import { RightModalBox } from "../qrCode/right-modal-box";
import { LeftDisabledBox } from "../qrCode/left-disabled-box";
import { LeftActiveBox } from "../qrCode/left-active-box";
import { Button } from "../../components";
import Contacts from "../../components/Contacts";
import { spaikIcon } from "../../assets";
import { setShowModalContacts } from "../../redux/slices/omnichannel";
import { useAppSelector, useAppDispatch } from "../../redux/hooks";

const IdentificationBar = () => {
  interface IWhatsappInstanceInfo {
    error: string;
    message: string;
    instance_data: {
      instance_key: string;
      phone_connected: string;
      webhookUrl: string;
      user: {
        id: string;
        name: string;
        phone: string;
      };
    };
  }

  const [whatsappInstanceInfo, setWhatsappInstanceInfo] =
    useState<IWhatsappInstanceInfo>({} as IWhatsappInstanceInfo);

  const { user } = useAuth() as AuthContextType;

  const [displayModal, setDisplayModal] = useState(false);
  const [leftBoxState, setActiveLeftBox] = useState(false);
  const [showContacts, setShowContacts] = useState(false);
  const dispatch = useAppDispatch();

  const showModalContacts = useAppSelector(
    (state) => state.omnichannel.showModalContacts
  );

  const userProfiles = () => {
    let profiles = "";

    if (user.profiles.length > 1) {
      user.profiles.forEach((element, index) => {
        if (index > 0) {
          profiles += ", ";
        }

        profiles += element;
      });
    } else {
      profiles = user.profiles[0];
    }

    return profiles;
  };

  const onDesconnect = () => setDisplayModal(false);

  const getWhatsappInstanceInfo = (instanceInfo: IWhatsappInstanceInfo) => {
    if (instanceInfo?.instance_data?.phone_connected == "true") {
      setWhatsappInstanceInfo(instanceInfo);

      setActiveLeftBox(true);
    } else {
      setActiveLeftBox(false);
    }
  };

  useEffect(() => {
    if (!showModalContacts) {
      setShowContacts(false);
    }
  }, [showModalContacts]);

  return (
    <div
      css={css`
        align-items: center;
        border-bottom: 1px solid #282d35;
        display: flex;
        padding: 12px;

        @media screen and (max-width: 499px) {
          gap: 0.5rem;
        }
      `}
    >
      <Avatar name={user.name} />

      <div style={{ width: "60%", paddingRight: "15px" }}>
        <div
          style={{
            alignItems: "center",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            fontSize: "16px",
            width: "100%",
            marginRight: "5px",
            overflow: "hidden",
            color: "#ffffff"
          }}
        >
          Olá, {user.name}
        </div>

        <div
          style={{
            width: "100%",
            alignItems: "center",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            fontSize: "12px",
            marginRight: "5px",
            overflow: "hidden",
            color: "#90a0b7"
          }}
        >
          {userProfiles()}
        </div>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          gap: "10px"
        }}
      >
        <img
          css={css`
            cursor: pointer;
            @media screen and (max-width: 499px) {
              display: none;
            }
          `}
          src={QrCode}
          width={25}
          height={25}
          onClick={() => setDisplayModal(true)}
        />

        <Button
          icon="pi pi-plus"
          onClick={() => {
            setShowContacts(true);
            dispatch(setShowModalContacts(true));
          }}
          style={{
            backgroundColor: user.plataform.mainColor || "#2624CD",
            borderColor: user.plataform.mainColor || "#2624CD"
          }}
        />
      </div>

      <DialogPadrao
        displayDialog={displayModal}
        contentStyle={{ height: "475px" }}
        onHide={() => setDisplayModal(false)}
        headerStyle={{
          backgroundColor: user.plataform.mainColor || "#2624CD"
        }}
      >
        <ContainerLeftModal>
          {leftBoxState ? (
            <LeftActiveBox
              name={whatsappInstanceInfo.instance_data.user.name}
              phone={whatsappInstanceInfo.instance_data.user.phone}
              emitDisconnect={onDesconnect}
            />
          ) : (
            <LeftDisabledBox />
          )}
        </ContainerLeftModal>

        <ContainerRightModal
          style={{ backgroundColor: user.plataform.mainColor || "#2624CD" }}
        >
          <RightModalBox emitWhatsappInfo={getWhatsappInstanceInfo} />
        </ContainerRightModal>
      </DialogPadrao>
      <div>
        {showContacts && (
          <DialogPadrao
            displayDialog={showContacts}
            contentStyle={{ height: "600px" }}
            onHide={() => setShowContacts(false)}
            headerStyle={{
              backgroundColor: user.plataform.mainColor || "#2624CD"
            }}
          >
            <ContainerLeftModal>
              <Contacts />
            </ContainerLeftModal>

            <ContainerRightModal
              style={{ backgroundColor: user.plataform.mainColor || "#2624CD" }}
            >
              <div
                style={{
                  color: "white",
                  padding: "0px 30px"
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  {user.plataform.urlAvatar ? (
                    <img
                      src={user.plataform.urlAvatar}
                      style={{ height: "200px", marginTop: "-55px" }}
                    />
                  ) : (
                    <img
                      src={spaikIcon}
                      style={{ height: "200px", marginTop: "-55px" }}
                    />
                  )}
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "15px"
                  }}
                >
                  <div>Escolha um contato</div>

                  <div
                    style={{
                      fontSize: "12px",
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px"
                    }}
                  >
                    <div>
                      Escolha um contato existente para abrir uma nova sala de
                      atendimento com ele, mantendo o histórico centralizado no
                      Spaik.
                    </div>

                    <div>
                      Se o lead ainda não estiver cadastrado, você pode
                      adicioná-lo rapidamente e, em seguida, criar a sala para
                      iniciar a conversa.
                    </div>
                  </div>
                </div>
              </div>
            </ContainerRightModal>
          </DialogPadrao>
        )}
      </div>
    </div>
  );
};

export default IdentificationBar;
